import SvgIcon from '@mui/material/SvgIcon';
import React from 'react';
import PALETTE from 'react/shared/theme/palette';

export default function SpendingMonitorIcon(props) {
  return (
    <SvgIcon alt="Spending Monitor Icon" viewBox="0 0 22 20" {...props}>
      <path
        clipRule="evenodd"
        d="M12.1 8.8C10.0497 8.8 8.32703 7.39775 7.83858 5.5H0V3.3H7.83858C8.32703 1.40225 10.0497 0 12.1 0C14.53 0 16.5 1.96995 16.5 4.4C16.5 6.83005 14.53 8.8 12.1 8.8ZM18.7 3.3H22V5.5H18.7V3.3ZM6.60003 19.8C4.54981 19.8 2.8271 18.3977 2.33865 16.5H0V14.3H2.33865C2.8271 12.4022 4.54981 11 6.60003 11C9.03009 11 11 12.9699 11 15.4C11 17.83 9.03009 19.8 6.60003 19.8ZM13.2 16.5H22V14.3H13.2V16.5ZM8.79996 15.4C8.79996 16.615 7.81499 17.6 6.59997 17.6C5.38494 17.6 4.39997 16.615 4.39997 15.4C4.39997 14.1849 5.38494 13.2 6.59997 13.2C7.81499 13.2 8.79996 14.1849 8.79996 15.4ZM14.3 4.40003C14.3 5.61506 13.315 6.60003 12.1 6.60003C10.885 6.60003 9.9 5.61506 9.9 4.40003C9.9 3.18501 10.885 2.20003 12.1 2.20003C13.315 2.20003 14.3 3.18501 14.3 4.40003Z"
        fill={PALETTE.emerald}
        fillRule="evenodd"
      />
    </SvgIcon>
  );
}
